import CollapsibleDetailView from "@components/molecules/CollapsibleDetailView";
import PriceDetailView from "@components/molecules/PriceDetailView";
import { PRICING_COMMENT_PREVIEW_LINES } from "@components/molecules/PriceDetailView/PricingCommentText";
import { useTypographyStore } from "@redux/slices/typographySlice";
import React, { useCallback, useMemo, useRef, useState } from "react";
import { useTheme } from "styled-components/native";
import styled from "styled-components/native";
import { ProductCommentViewProps } from "../types";
import { PriceModes } from "@components/molecules/PriceModeCard/types";
import { useUserInfo } from "@redux/slices/userInfoSlice";

const ProductCommentView = ({
  ref,
  itemDetail,
  productColor,
  priceMode,
  productType,
  onLayout,
}: ProductCommentViewProps) => {
  const theme = useTheme();
  const typography = useTypographyStore();
  const isIFrame = useUserInfo().isIFrame();
  const [expandView, setExpandView] = useState(isIFrame);
  const [commentMeasurement, setCommentMeasurement] = useState({
    comment: "",
    lineCount: 0,
  });
  const pricingCommentRef = useRef(itemDetail?.pricing_comment ?? "");
  pricingCommentRef.current = itemDetail?.pricing_comment ?? "";
  const measuredCurrentComment =
    commentMeasurement.comment === pricingCommentRef.current &&
    commentMeasurement.lineCount > 0;
  const showCommentArrow =
    measuredCurrentComment &&
    commentMeasurement.lineCount > PRICING_COMMENT_PREVIEW_LINES;
  const commentFitsInPreview =
    measuredCurrentComment &&
    commentMeasurement.lineCount <= PRICING_COMMENT_PREVIEW_LINES;

  const handleCommentLineCount = useCallback((lineCount: number) => {
    const comment = pricingCommentRef.current;
    setCommentMeasurement((current) =>
      current.comment === comment && current.lineCount === lineCount
        ? current
        : { comment, lineCount }
    );
  }, []);

  const DetailComponent = useMemo(() => {
    return (
      <PriceDetailContainer>
        <PriceDetailView
          itemDetail={itemDetail}
          priceMode={priceMode}
          productType={productType}
          productColor={productColor}
          expandView={expandView}
          maxCollapsedCommentLines={
            priceMode === PriceModes.WHITE
              ? commentFitsInPreview
                ? undefined
                : PRICING_COMMENT_PREVIEW_LINES
              : 1
          }
          onCommentLineCount={handleCommentLineCount}
        />
      </PriceDetailContainer>
    );
  }, [
    itemDetail,
    priceMode,
    productType,
    productColor,
    typography,
    expandView,
    itemDetail?.total_sales_price,
    itemDetail?.pricing_comment,
    handleCommentLineCount,
    commentFitsInPreview,
  ]);

  return (
    <Container ref={ref} onLayout={onLayout}>
      {itemDetail?.pricing_comment &&
      priceMode === PriceModes.WHITE &&
      !isIFrame ? (
        <CollapsibleDetailView
          expandView={expandView}
          setExpandView={setExpandView}
          initExpanded={expandView}
          title={DetailComponent}
          arrowStyling={{ color: theme["core-06"] }}
          forceExpand={true}
          hideArrowBar={!showCommentArrow}
        />
      ) : (
        <>{DetailComponent}</>
      )}
    </Container>
  );
};

const Container = styled.View``;

const PriceDetailContainer = styled.View`
  flex-direction: column;
`;

export default ProductCommentView;
